import { NgModule } from '@angular/core';

import { WaitForImageDirective } from './wait-for-image.directive';

@NgModule({
  declarations: [WaitForImageDirective],
  exports: [WaitForImageDirective]
})
export class WaitForImageModule {}
